<template>
  <div>
    <div class="comment-box bg-skin-secondary">
      <div class="header-box">
        <UserProfile :data="item.user.person" />
        <div class="info-profile ml-2">
          <div class="name-user text-skin-secondary">{{ item.user.name }}</div>
          <div class="time-comment text-skin-secondary">
            {{
              moment(item.created_at)
                .startOf("day")
                .fromNow()
            }}
          </div>
        </div>
        <div class="flex flex-grow justify-end" v-if="item.user.id == userId.id">
          <button class="edit opacity-25 transition duration-300 hover:opacity-100"
          :class="{'opacity-50':this.GET_LOADDING}"
          @click.prevent.stop="editQuestion"
          :disabled="this.GET_LOADDING">
            <Edit 
              class="cursor-pointer"
              width="20px"
              height="20px"
            />
          </button>
          <button v-if="item.answers.length==0" class="delete ml-2 opacity-25 transition duration-300 hover:opacity-100"
          :class="{'opacity-50':this.GET_LOADDING}"
          @click.prevent.stop="deleteQuestion"
          :disabled="this.GET_LOADDING">
            <Delete 
              class="cursor-pointer"
              width="20px"
              height="20px"
            />
          </button>

        </div>
      </div>
      <div class="comment mt-3 text-skin-secondary">
        <span>{{ item.questions }} </span>
      </div>
      <div class="actions mt-3" v-if="!answersBox">
        <button class="reply cursor-pointer text-blueCambiando disabled:opacity-40"
        :disabled="this.GET_LOADDING" @click="replyBox = true">Responder</button>
        <div
          class="view-reply"
          v-if="item.answers.length > 0"
          @click="answersBox = true"
        >
          {{ item.answers.length }} Ver Respuestas
        </div>
      </div>

      <collapse-transition>
        <div v-if="answersBox" class="ml-2">
          <div v-for="data in item.answers" :key="data.id">
            <ReplyBox :item="data"></ReplyBox>
          </div>
        </div>
      </collapse-transition>

      <div class="actions mt-3" v-if="answersBox">
        <button class="reply cursor-pointer disabled:opacity-40" 
        :disabled="this.GET_LOADDING" @click="replyBox = true">Responder</button>
        <div
          class="view-reply"
          v-if="item.answers.length > 0"
          @click="answersBox = false"
        >
          {{ item.answers.length }} Ocultar Respuestas
        </div>
      </div>
      <collapse-transition>
        <NoteCreateBox
          v-if="replyBox"
          :disabled="this.GET_LOADDING"
          @cancel="replyBox = false"
          @saveNote="saveAnswers"
          :placeholder="'Escribe una respuesta'"
          :noBox="false"
          :showTimer="false"
        ></NoteCreateBox>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ReplyBox from "../components/ReplyBox.vue";
import UserProfile from "../components/UserCommets.vue";
import NoteCreateBox from "../components/NoteCreateBox.vue";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import Edit from "./icons/Edit.vue";
import Delete from "./icons/Delete.vue";

export default {
  components: {
    ReplyBox,
    UserProfile,
    NoteCreateBox,
    CollapseTransition,
    Edit, 
    Delete
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("detailCourse", ["GET_MOUNTED_COURSE"]),
    ...mapGetters("questions", ["GET_LOADDING"]),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  data() {
    return {
      replyBox: false,
      answersBox:false,
    };
  },
  methods: {
    saveAnswers(template) {
      let body = {
        question_id: this.item.id,
        user_id: this.userId.id,
        answers: template,
        mounted_course_id: this.$route.params.id,
      };

      this.$store.dispatch("questions/post_answer_course", {
        _body: body,
      }).then(() => {
        this.answersBox = true;
        this.replyBox = false;
      })

    },
    editQuestion() {
      if(!this.GET_LOADDING){
        this.$store.commit("questions/SET_QUESTION_EDIT", true);
        this.$store.commit("questions/SET_QUESTION_SELECTED", this.item);
        this.$emit("change");
      }
    },
    deleteQuestion() {
      if(!this.GET_LOADDING){
        this.$store.dispatch("questions/delete_questions_course", {
          _question_id: this.item.id,
        });
      }
    },
  },
};
</script>

<style scoped>
.comment-box {
  box-shadow: 1px 2px 5px #00000029;
  opacity: 1;
  padding: 17px 13px 13px 17px;
  height: auto;
  margin-top: 20px;
}
.reply-box {
  opacity: 1;
  padding: 17px 13px 13px 17px;
  height: auto;
  margin-top: 20px;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reply {
  background: #c6c6c6 ;
  border-radius: 13px;
  padding: 2px 10px;
  font-size: 13px;
  margin-left: 20px;
  transition: all 0.5s;
  outline: none;
}
.reply:hover {
  background: #db2777;
}

.view-reply {
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  color: #f28062;
  cursor: pointer;
}

.view-more {
  color: #f28062;
  cursor: pointer;
}

.profile-image {
  width: 36px;
  height: 35px;
  background: #ef8d6e;
  border-radius: 50%;
}

.name-user {
  font: normal normal bold 15px/18px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.time-comment {
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.header-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.comment {
  text-align: left;
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
}
</style>
